export default __webpack_public_path__ + "static/media/EAST1060.34I-34187_-18433_0.98c02edc.jpg";